<template>
    <section>
        <!-- リスト -->
        <el-table :data="contents" highlight-current-row v-loading="listLoading"
                  style="width: 100%;">
            <el-table-column prop="name" label="コンテンツ名" width="300" >
            </el-table-column>
            <el-table-column prop="price" label="価格" width="120" >
            </el-table-column>
            <el-table-column label="公開期間" width="300" >
                <template scope="scope">
                    {{ scope.row.publishBegin | formatDate }} - {{ scope.row.publishEnd | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="視聴期間" width="300" >
                <template scope="scope">
                    {{ scope.row.showBegin | formatDate }} - {{ scope.row.showEnd | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="シリーズ" width="300" >
                <template scope="scope">
                    <span v-if="'series' in scope.row">
                        <span v-if="'parent' in scope.row.series">{{ scope.row.series.parent.name }} > </span>
                        {{ scope.row.series.name }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="サムネイル" width="300" >
                <template scope="scope">
                    <img class="trim" width="100" height="100"
                         v-for="image in scope.row.images"
                         :src="`${config.aws.s3.getbucket}/images/${image.path}`">
                </template>
            </el-table-column>
            <el-table-column label="カテゴリ" width="300" >
                <template scope="scope">
                    <span v-for="category in scope.row.categories">
                        {{ category.name }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="contentsId" label="コンテンツID" width="300" >
            </el-table-column>
            <el-table-column label="ビュー" width="300">
                <template scope="scope">
                    <el-button size="small" @click="addView(scope.row.id)">視聴したことにする</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->
    </section>
</template>

<script>
    import util from '../common/js/util'
    import * as ContentRequest from '../api/content';
    import * as ViewRequest from '../api/view';
    import * as UserRequest from '../api/user';
    import * as CategoryRequest from '../api/category';
    import * as SeriesRequest from '../api/series';
    import * as MovieRequest from '../api/movie';
    import * as ImageRequest from '../api/image';
    import ElOption from "../../node_modules/element-ui/packages/select/src/option.vue";
    import config from '../config/app';
    import { formatDate } from "../components/filters/format";

    export default {
        components: {
            ElOption,
        },
        filters: {
            formatDate,
        },
        data() {
            return {
                filters: {
                    name: ''
                },
                config: config,
                contents: [],
                total: 0,
                page: 1,
                listLoading: false,
            }
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
                this.getContents();
            },
            getContents() {
                const user = JSON.parse(sessionStorage.getItem('user'));

                let params = {
                    params: {
                        fields: "name",
                        q: this.filters.name,
                        order: "priority",
                        sort: "asc",
                        username: user.username,
                    }
                };
                this.listLoading = true;
                ContentRequest
                    .searchByUser(params)
                    .then(res => {
                        this.contents = res.data.map(content => {
                            return content;
                        });
                        this.listLoading = false;
                    });
            },
            addView(id) {
                ContentRequest
                    .addView({
                        params: {
                            contentId: id,
                            sessionId: id,
                            vtkt: id,
                        },
                    })
                    .then(res => {
                        console.log(res);
                    });
            }
        },
        mounted() {
            this.getContents();
        }
    }

</script>

<style scoped>
    .trim {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: 100px;
    }
</style>


// WEBPACK FOOTER //
// User.vue?08c57f2a